module.exports = __webpack_public_path__ + "static/media/组 63@3x.4443e979.png";